import { type FC } from 'react'

import { Dialog, type DialogProps } from '@/components'
import { useSignOut } from '@/hooks'

export const LogoutDialog: FC<Omit<DialogProps, 'onConfirm'>> = ({
  children = 'Are you sure you want to logout?',
  isOpen,
  onClose,
  ...props
}) => {
  const [signOut, isSigningOut] = useSignOut(onClose)

  return (
    <Dialog
      confirmLabel={isSigningOut ? 'Logging out' : 'Logout'}
      isLoading={isSigningOut}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={signOut}
      title='Confirm Logout'
      {...props}
    >
      {children}
    </Dialog>
  )
}
